export default __webpack_public_path__ + "static/media/uturn-right.e7133132.svg";